<template>
  <div class="pathview">
    <div id="pathmap"></div>
    <div class="ctrl">
      <el-input
        style="margin-right: 10px"
        v-model="searchTxt"
        placeholder="请输入转运站名称"
      ></el-input>
      <el-button type="primary" class="item-primary" @click="searchStation"
        >查询</el-button
      >
      <el-button type="info" class="item-info" @click="reset">重置</el-button>
    </div>
    <div class="state-list">
      <div class="state-item">
        <div class="state-icon online"></div>
        <div>在线</div>
        <div class="num">{{ onlineNum }}</div>
      </div>
      <div class="state-item">
        <div class="state-icon offline"></div>
        <div>离线</div>
        <div class="num">{{ offlineNum }}</div>
      </div>
      <div class="state-item">
        <div class="state-icon move"></div>
        <div>位移</div>
        <div class="num">{{ moveNum }}</div>
      </div>
    </div>
    <div
      v-show="stationTip.show"
      @mouseenter="clearHideWin"
      @mouseleave="stationTip.show = false"
      class="pathview-marker-tip"
      :style="{ left: stationTip.x + 'px', top: stationTip.y + 'px' }"
    >
      <div class="title">
        <span class="size bold"
          >{{ stationTip.name }}-{{ stationTip.box }}箱</span
        >
        <div class="pos">
          <img class="img" src="../assets/img/pos_icon.png" />
          <span class="color" @click="openPath">查看轨迹</span>
        </div>
      </div>
      <div class="location">
        设备当前位置：<span class="bold">{{ stationTip.location }}</span>
      </div>
      <div>
        定位上次更新时间：<span class="bold">{{ stationTip.update }}</span>
      </div>
    </div>
    <div
      class="viewpath"
      v-show="shouPathMap"
      v-loading="pathLoad"
      element-loading-text="拼命加载中"
    >
      <div id="viewpathmap"></div>
      <div class="pathctrl">
        <el-button class="item-primary" type="primary" @click="backmap"
          >返回</el-button
        >
        <el-date-picker
          style="margin: 0 10px"
          v-model="selTime"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :clearable="false"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
        <!-- <div class="block">
          <el-date-picker
            v-model="beginTime"
            type="datetime"
            placeholder="选择开始日期时间"
            default-time="12:00:00"
            @change="select"
            :picker-options="pickerOptions0"
          >
          </el-date-picker>
        </div>
        <div class="block">
          <el-date-picker
            v-model="overTime"
            type="datetime"
            placeholder="选择结束日期时间"
            default-time="12:00:00"
            :picker-options="pickerOptions1"
          >
          </el-date-picker>
        </div> -->
        <el-button class="item-primary" type="primary" @click="searchTime"
          >查询</el-button
        >
        <el-button
          class="item-primary"
          type="primary"
          @click="lushuStart"
          :disabled="showBtn"
          >开始</el-button
        >
        <el-button class="item-primary" type="primary" @click="lushuPause"
          >暂停</el-button
        >
        <el-button class="item-primary" type="primary" @click="lushuStop"
          >停止</el-button
        >
      </div>
      <div class="infobox" v-show="stationShow">
        <div class="title">{{ stationInfo.transferPointName }}</div>
        <table class="table">
          <tr>
            <td>清运车辆：</td>
            <td>{{ stationInfo.vehicle }}</td>
          </tr>
          <tr>
            <td>联系电话：</td>
            <td>{{ stationInfo.transferPhone }}</td>
          </tr>
          <tr>
            <td>箱体：</td>
            <td>{{ stationInfo.box }}箱</td>
          </tr>
          <tr>
            <td>清运单位：</td>
            <td>{{ stationInfo.managementDeptName }}</td>
          </tr>
          <tr>
            <td>状态：</td>
            <td>
              <span v-if="stationInfo.status === 0">离线</span>
              <span v-if="stationInfo.status === 1">在线</span>
              <span v-if="stationInfo.status === 2">位移</span>
            </td>
          </tr>
          <tr>
            <td>方向：</td>
            <td>
              <span>{{ stationInfo.direction }}</span>
            </td>
          </tr>
          <tr>
            <td>行驶速度：</td>
            <td>{{ stationInfo.speed }}KM/h</td>
          </tr>
          <tr>
            <td>定位方式：</td>
            <td>
              <span v-if="stationInfo.locatioType === '0'">Wifi</span>
              <span v-if="stationInfo.locatioType === '1'">GPS</span>
            </td>
          </tr>
          <tr>
            <td>设备地址码：</td>
            <td>{{ stationInfo.deviceAddress }}</td>
          </tr>
          <tr>
            <td>最后定位时间：</td>
            <td>{{ stationInfo.createTime }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import icon_online from "../assets/img/st_icon_3.png";
import icon_offline from "../assets/img/st_icon_2.png";
import icon_move from "../assets/img/st_icon_1.png";
import axios from "../request";
import { Message } from "element-ui";
import Feature from "ol/Feature";
import Point from "ol/geom/Point";
import { Style, Icon } from "ol/style";
import PathAnimator from "../utils/pathAnimator";
import {
  createTiandituMap,
  destroyTiandituMap,
  setMapCenterByBd09,
  clearMapVectorFeatures,
  bd09ToMapCoord,
  reverseGeocodeByBd09,
  fitMapToBd09Coords,
} from "../utils/tiandituMap";
export default {
  name: "PathView",
  data() {
    let that = this;
    return {
      pickerRange: 3600 * 1000 * 24 * 1,
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          if (minDate && that.pickerMinDate) {
            that.pickerMinDate = null;
          } else if (minDate) {
            that.pickerMinDate = minDate.getTime();
          }
        },
        disabledDate: (time) => {
          if (that.pickerMinDate) {
            return (
              time.getTime() > that.pickerMinDate + that.pickerRange ||
              time.getTime() < that.pickerMinDate - that.pickerRange
            );
          }
          return false;
        },
      },
      pathLoad: false,
      showBtn: false,
      shouPathMap: false,
      stationShow: false,
      searchTxt: "",
      selTime: "",
      map: null,
      pathMap: null,
      stationTipFeature: null,
      stationTip: {
        show: false,
        name: "",
        x: 0,
        y: 0,
        location: "",
        update: "",
      },
      pos: {
        x: 0,
        y: 0,
      },
      stateIcon: {
        0: icon_offline,
        1: icon_online,
        2: icon_move,
      },
      stationList: [
        {
          state: 1,
          lng: 116.417,
          lat: 39.909,
          name: "转运站1",
          location: "岔路口",
          update: "2021-04-06 12:02:01",
        },
        {
          state: 2,
          lng: 116.4,
          lat: 39.909,
          name: "转运站2",
          location: "岔路口",
          update: "2021-04-06 12:02:01",
        },
        {
          state: 3,
          lng: 116.4,
          lat: 39.89,
          name: "转运站3",
          location: "岔路口",
          update: "2021-04-06 12:02:01",
        },
      ],
      markerList: [],
      onlineNum: 0,
      offlineNum: 0,
      moveNum: 0,
      curIndex: 0,
      pathList: [],
      stationInfo: {
        deviceAddress: "", //设备地址码
        transferPointName: "", //转运站名称
        managementDeptName: "", //清运单位
        vehicle: "", //清运车
        transferPhone: "", //联系电话
        direction: "", //方向
        speed: "", //速度
        locatioType: "", //定位类型 0 wifi定位  1 gps定位
        status: "", //状态，1在线，0离线 2 位移
        createTime: "", //时间
      },
      curDeviceAddress: "",
      ani: null,
      lushu: null,
      drv: null,
      hasPath: false,
      timer: null,
      timerMiss: false,
      ctime: null,
      isSearch: false,
      poinList: [],
      geocoder: null,
      beginTime: "",
      overTime: "",
      refresh: null,
    };
  },
  created() {
    // this.init();
  },
  mounted() {
    this.initStationMap();
    this.initPathMap();
    this.getPointData();
    this.refresh = setInterval(() => {
      this.clearStationMarkers();
      this.getPointData();
    }, 30000);
  },
  destroyed() {
    clearInterval(this.refresh);
    destroyTiandituMap(this.map);
    destroyTiandituMap(this.pathMap);
  },

  methods: {
    select() {
      console.log(this.beginTime);
      this.pickerOptions = {
        disabledDate(time) {
          // return time.getTime() < new Date(this.beginTime).getTime();
          return this.beginTime;
        },
      };
    },
    // 关闭sorket
    // init() {
    //   if (typeof WebSocket === "undefined") {
    //     alert("您的浏览器不支持socket");
    //   } else {
    //     console.log(sessionStorage.getItem("id"));
    //     this.socket = new WebSocket(
    //       this.websocketUrl.socketRoot + sessionStorage.getItem("id")
    //     ); // 实例化socket
    //     console.log(this.socket);
    //     this.socket.onopen = this.open; // 监听socket连接
    //     this.socket.onerror = this.error; // 监听socket错误信息
    //     this.socket.onmessage = this.getMessage; // 监听socket消息
    //     this.socket.onclose = this.close; // 关闭socket消息
    //   }
    // },
    // open() {
    //   console.log("温度socket连接成功");
    // },
    // getMessage(msg) {
    //   this.webdatalist = JSON.parse(msg.data);
    //   if (
    //     this.webdatalist.header.moduleType == "trajectory" &&
    //     this.webdatalist.header.msgType == "transferPoint"
    //   ) {
    //     let item = this.webdatalist.body.body;
    //     const marker = this.createMarker(
    //       item.status,
    //       item.longitude,
    //       item.latitude
    //     );
    //     const that = this;
    //     marker.addEventListener("mouseover", function (e) {
    //       if (that.stationTip.show === true) return;
    //       that.stationTip.x = e.Wa.x;
    //       that.stationTip.y = e.Wa.y;
    //       that.stationTip.name = item.transferPointName;
    //       // that.stationTip.update = item.updateTime;
    //       that.stationTip.update = this.shijianc(item.updateTime);
    //       that.stationTip.box = item.box;
    //       that.stationTip.show = true;
    //       that.curDeviceAddress = item.deviceAddress;
    //       that.geocoder.getLocation(
    //         new BMap.Point(item.longitude, item.latitude),
    //         (opt) => {
    //           that.stationTip.location = opt.address;
    //         }
    //       );
    //     });
    //     marker.addEventListener("mouseout", function (e) {
    //       that.timer = setTimeout(() => {
    //         that.stationTip.show = false;
    //       }, 300);
    //     });
    //   }
    // },
    // 时间戳转年月日时分秒
    shijianc(time) {
      let date = new Date(time);
      let Y = date.getFullYear() + "-";
      let M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      let D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      let h =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      let m =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      let s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    },

    initStationMap() {
      this.map = createTiandituMap("pathmap", {
        center: [118.681728, 37.43865],
        zoom: 13,
      });
      this.map.on("pointermove", (evt) => {
        if (this.stationTip.show) return;
        const feature = this.map.forEachFeatureAtPixel(evt.pixel, (item) => item);
        if (feature && feature.get("stationData")) {
          const item = feature.get("stationData");
          this.stationTip.x = evt.originalEvent.pageX;
          this.stationTip.y = evt.originalEvent.pageY;
          this.stationTip.name = item.transferPointName;
          this.stationTip.update = item.updateTime;
          this.stationTip.box = item.box;
          this.stationTip.show = true;
          this.curDeviceAddress = item.deviceAddress;
          reverseGeocodeByBd09(item.longitude, item.latitude).then((address) => {
            this.stationTip.location = address;
          });
        }
      });
      this.map.on("pointerleave", () => {
        this.timer = setTimeout(() => {
          this.stationTip.show = false;
        }, 300);
      });
    },
    initPathMap() {
      this.pathMap = createTiandituMap("viewpathmap", {
        center: [118.681728, 37.43865],
        zoom: 13,
      });
    },
    clearStationMarkers() {
      this.markerList.forEach((feature) => {
        this.map.__vectorSource.removeFeature(feature);
      });
      this.markerList = [];
    },
    clearPathMap() {
      if (this.lushu) {
        this.lushu.stop();
        this.lushu = null;
      }
      if (this.pathMap) {
        clearMapVectorFeatures(this.pathMap);
      }
    },
    createMarker(state, lng, lat, stationData) {
      const feature = new Feature({
        geometry: new Point(bd09ToMapCoord(lng, lat)),
        stationData,
      });
      feature.setStyle(
        new Style({
          image: new Icon({
            src: this.stateIcon[state],
            anchor: [0.5, 1],
            scale: 1,
          }),
        })
      );
      this.markerList.push(feature);
      this.map.__vectorSource.addFeature(feature);
      return feature;
    },
    searchStation() {
      if (!this.searchTxt) return;
      this.isSearch = true;
      this.clearStationMarkers();
      this.getPointData();
    },
    clearHideWin() {
      clearTimeout(this.timer);
    },
    addMarker() {
      this.stationList.forEach((item) => {
        this.createMarker(item.status, item.longitude, item.latitude, item);
      });
      if (this.stationList.length > 0 && this.isSearch) {
        const pos = this.stationList[0];
        setMapCenterByBd09(this.map, pos.longitude, pos.latitude, 15);
      }
      if (this.stationList.length < 1 && this.isSearch) {
        Message({
          message: "未查询到该转运站",
          showClose: true,
          type: "warning",
        });
      }
    },
    backmap() {
      this.showBtn = false;
      this.shouPathMap = false;
      this.stationShow = false;
      this.selTime = null;
      this.showBtn = false;
      this.hasPath && this.lushu && this.lushu.stop();
      this.clearPathMap();
    },
    reset() {
      this.searchTxt = "";
      this.isSearch = false;
      this.getPointData();
      setMapCenterByBd09(this.map, 118.681728, 37.43865, 13);
    },
    createTimeDate() {
      let time = new Date();
      let ms = time.getTime() - 24 * 60 * 60 * 1000;
      let end = [
        time.getFullYear(),
        time.getMonth(),
        time.getDate(),
        time.getHours(),
        time.getMinutes(),
        time.getSeconds(),
      ];
      time.setTime(ms);
      let start = [
        time.getFullYear(),
        time.getMonth(),
        time.getDate(),
        time.getHours(),
        time.getMinutes(),
        time.getSeconds(),
      ];
      let start2 = `${start[0]}-${start[1] + 1}-${start[2]} ${start[3]}:${
        start[4]
      }:${start[5]}`;
      let end2 = `${end[0]}-${end[1] + 1}-${end[2]} ${end[3]}:${end[4]}:${
        end[5]
      }`;
      return { start, end, start2, end2 };
    },
    openPath() {
      let t = (this.ctime = this.createTimeDate());
      this.selTime = [t.start2, t.end2];
      this.shouPathMap = true;
      this.pathLoad = true;
      this.stationTip.show = false;
      this.$nextTick(() => {
        if (this.pathMap) {
          this.pathMap.updateSize();
        }
      });
      this.getPathData(t.start2, t.end2);
    },
    dealdate(date) {
      const dt = new Date(date);
      const y = dt.getFullYear();
      const m = (dt.getMonth() + 1 + "").padStart(2, "0");
      const d = (dt.getDate() + "").padStart(2, "0");
      const hh = (dt.getHours() + "").padStart(2, "0");
      const mm = (dt.getMinutes() + "").padStart(2, "0");
      const ss = (dt.getSeconds() + "").padStart(2, "0");
      return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
    },

    searchTime() {
      this.hasPath && this.lushu && this.lushu.stop();
      this.clearPathMap();
      this.showBtn = false;
      if (this.selTime === null) return;

      let start = new Date(this.selTime[0].replace(/-/g, "/"));
      let end = new Date(this.selTime[1].replace(/-/g, "/"));
      console.log(this.selTime);
      if (end.getTime() - start.getTime() > 24 * 60 * 60 * 1000) {
        this.$message({
          type: "error",
          showClose: true,
          message: "数据量过大,暂只查询一天轨迹数据",
        });
        return false;
      }
      this.pathLoad = true;
      if (typeof this.selTime[0] === "string") {
        this.getPathData(this.selTime[0], this.selTime[1]);
      } else {
        this.getPathData(this.ctime.start2, this.ctime.end2);
      }
    },
    createPathAni() {
      if (!this.pathMap) {
        this.initPathMap();
      }
      this.clearPathMap();
      this.pathMap.updateSize();

      if (!this.pathList.length) return;

      const coords = this.pathList.map((item) => [item.longitude, item.latitude]);
      fitMapToBd09Coords(this.pathMap, coords, { maxZoom: 15 });

      this.lushu = new PathAnimator(this.pathMap, this.pathList, {
        speed: 200,
        iconSrc: icon_online,
        onIndexChange: (index) => {
          if (this.pathList[index]) {
            this.stationInfo = { ...this.pathList[index] };
          }
        },
      });
    },
    async getPathData(start, end) {
      const query = {
        deviceAddress: this.curDeviceAddress,
        startTime: start,
        endTime: end,
      };
      let data = await axios.get("/transferPointDetail/findTrajectory", {
        params: query,
      });
      if (data) {
        this.hasPath = true;
        this.pathList = data;
        this.stationInfo = data[data.length - 1];
        console.log(this.stationInfo);
        this.stationShow = true;
        this.createPathAni();
      } else {
        this.hasPath = false;
        Message({
          message: "暂无轨迹数据",
          showClose: true,
          type: "warning",
        });
      }
      this.pathLoad = false;
    },
    // 获取站点位置数据
    async getPointData() {
      let data = await axios.get("/transferPointDetail/findAll", {
        params: { transferPointName: this.searchTxt },
      });
      if (data) {
        this.stationList = data.transferPointDetailVos;
        this.onlineNum = data.onlineCount;
        this.offlineNum = data.offlineCount;
        this.moveNum = data.displacementCount;
        this.clearStationMarkers();
        this.addMarker();
      }
    },
    lushuStart() {
      this.hasPath && this.lushu.start();
      this.showBtn = true;
    },
    lushuPause() {
      this.hasPath && this.lushu.pause();

      this.showBtn = false;
    },
    lushuStop() {
      this.hasPath && this.lushu.stop();
      this.showBtn = false;
    },
  },
};
</script>

<style scoped lang="scss">
#pathmap {
  width: 100%;
  height: 100%;
}
.pathview {
  width: 100%;
  height: 100%;
  background-color: white;
  position: relative;
}
.state-list {
  position: absolute;
  left: 50px;
  bottom: 50px;
  // width: 229px;
  height: 150px;
  background: #ffffff85;
  border: 2px solid #408dff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  .state-item {
    display: flex;
    align-items: center;
  }
  .state-icon {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    margin: 0 20px;
  }
  .num {
    font-weight: bold;
    margin: 0 20px;
  }
  .online {
    background: #89e56e;
  }
  .offline {
    background: #7f7f7f;
  }
  .move {
    background: #ff632c;
  }
}
.pathview-marker-tip {
  z-index: 10;
  position: absolute;
  background-color: white;
  border: solid 2px rgb(61, 61, 61);
  border-radius: 10px;
  padding: 10px;
  .bold {
    font-weight: bold;
  }
  .size {
    font-size: 1.2rem;
  }
  .pos {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .location {
    margin: 10px 0;
  }
  .img {
    margin-right: 6px;
  }
  .color {
    color: $blue;
    cursor: pointer;
  }
}
.ctrl {
  position: absolute;
  left: 20px;
  top: 20px;
  display: flex;
}
.viewpath {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  #viewpathmap {
    width: 100%;
    height: 100%;
  }
  .pathctrl {
    position: absolute;
    left: 10px;
    top: 10px;
    display: flex;
  }
  .infobox {
    padding: 10px 20px;
    box-sizing: content-box;
    color: white;
    position: absolute;
    right: 50px;
    top: 200px;
    // width: 339px;
    // height: 384px;
    background: linear-gradient(
      0deg,
      #ffffff 0%,
      #ffffff 0%,
      #ffffff 0%,
      #3c81ff 0%,
      #236df8 0%,
      #4e96ee 100%
    );
    border-radius: 8px;
    .title {
      font-size: 1.2rem;
      font-weight: bold;
      padding-bottom: 10px;
      border-bottom: solid 1px rgba(213, 231, 255, 0.4);
      margin-bottom: 10px;
    }
    .table {
      td {
        line-height: 2.5;
      }
    }
  }
}
</style>
